import styled from 'styled-components';

export const Container = styled.div`

    .modal {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1050;
        width: 100%;
        height: 100%;
        overflow: hidden;
        outline: 0;
        background-color: rgba( 0, 0, 0, .8 );
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 20000;
    
        .modal-dialog {
            min-height: calc(100vh - 60px);
            width: 100%;
            max-width: 500px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            overflow: auto;
            padding: 20px;

            .modal-content {
                background-color: #fff;
                display: flex;
                flex-direction: column;
                border-radius: 4px;
                width: 100%;

                .modal-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #ccc;
                    padding: 20px 15px;

                    h5 {
                        margin: 0;
                    }

                    button {
                        background: none;
                        border: none;
                        outline: none;

                        span {
                            font-weight: bolder;
                            font-size: 1.5em;
                        }
                    }
                }

                .modal-body {
                    padding: 20px 15px;
                }
            }            
        }
    }
`